module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "board-client-actions"
  }, [_c('header', {
    staticClass: "board-client-actions__header"
  }, [_c('h2', {
    staticClass: "dashboard-title dashboard-title--medium"
  }, [_vm._v("Vos clients")]), _vm._v(" "), _c('div', {
    staticClass: "board-client-actions__search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "board-client-actions__search-input search-form__input",
    attrs: {
      "id": "search_clients",
      "type": "text",
      "placeholder": "Quels clients cherchez-vous ?"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchClient.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "board-client-actions__search-btn",
    on: {
      "click": _vm.searchClient
    }
  }, [_vm._v("\n\t\t\t\tRechercher\n\t\t\t")])])]), _vm._v(" "), (_vm.searchError) ? _c('div', {
    staticClass: "board-client-actions__error"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.searchError) + "\n\t")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "dashboard-loading"
  }, [_vm._v("\n\t\tChargement...\n\t")]) : (_vm.hasSearched && _vm.filteredClients.length === 0) ? _c('div', {
    staticClass: "dashboard-empty"
  }, [_vm._v("\n\t\tAucun client trouvé\n\t")]) : _c('div', {
    staticClass: "dashboard-grid dashboard-grid--auto-fill"
  }, _vm._l((_vm.filteredClients), function(client) {
    return _c('CardClient', {
      key: client.id,
      attrs: {
        "user": client
      },
      on: {
        "renewal-updated": _vm.removeClient
      }
    })
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fd996be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Board/BoardClientActions.vue
// module id = 1148
// module chunks = 0